import { render, staticRenderFns } from "./number-animate.vue?vue&type=template&id=ab4019a8&scoped=true"
import script from "./number-animate.vue?vue&type=script&lang=js"
export * from "./number-animate.vue?vue&type=script&lang=js"
import style0 from "./number-animate.vue?vue&type=style&index=0&id=ab4019a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4019a8",
  null
  
)

export default component.exports